module.exports = __webpack_public_path__ + "img/mapMarker2.18c9560e.png";